
import './formCombo.scss'
import { useState, useEffect, useContext } from "react";
import loadingGif from '../../../../../assets/uploading.gif';
import ArticulosModal from '../../../articulosModal/articulosModal';
import ConfirmationDialog from "../../../../../components/dialogs/ConfirmationDialog";
import ErrorDialog from "../../../../../components/dialogs/ErrorDialog";
import { ArticulosFormContext } from '../../../../../context/articulos/ArticulosContext';
import { ArticulosCombosContext } from '../../../../../context/articuloscombos/ArticulosCombosContext';

export const FormDetalle = ({
  idArt,
  addItem,
  getItem,
  updateItem,
  estadoForm,
  setEstadoForm,
  arrayCombo,
  closeModal
}) => {
  const {
    getArticuloByIdData,
  } = useContext(ArticulosFormContext);
  const {
    patchArticuloComboData,
    getArticuloComboByIdData,

  } = useContext(ArticulosCombosContext);
  const [title, setTitle] = useState('');
  const [form, setForm] = useState({});
  const [errors, setErrors] = useState({});
  const [searchIdArt, setSearchIdArt] = useState();
  const [searchDescArt, setSearchDescArt] = useState();
  const [selectedRow, setSelectedRow] = useState();

  // Vista Previa
  const [uploadFormError, setUploadFormError] = useState('');  // Para el mensaje de error de imagen
  // estado de carga
  const [isSubmitting, setIsSubmitting] = useState(false);
  // Estado para controlar la apertura de los diálogos
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [isErrorDialogOpen, setIsErrorDialogOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  useEffect(() => {
    idArt ? setTitle('Editar Articulo Combo') : setTitle('Agregar Articulo Combo');
  }, [idArt])


  useEffect(() => {
    const fetchData = async () => {
      if (idArt) {
        // Verificar si el detalle está en el array
        const comboEnArray = arrayCombo.find((item) => item.id === idArt);

        if (comboEnArray) {
          if (comboEnArray) {
            setForm((prevForm) => ({
              ...prevForm,
              art_descripcion: comboEnArray?.oferta_Art?.art_descripcion || prevForm.art_descripcion || "",
              ...comboEnArray, // Usa comboEnArray correctamente si es un objeto plano
            }));

            setEstadoForm(1);
          }


          setEstadoForm(1);
        } else {
          try {
            // Si el ID no está en el array, buscar los datos desde la API
            const detalle = await getArticuloComboByIdData(idArt);
            if (detalle) {
              setForm(prevForm => ({
                ...prevForm,
                ...detalle,
                art_descripcion: detalle.Contenido_combo_hijo.art_descripcion || '',
              }));
              setEstadoForm(1);
            } else {
              console.error("No se encontraron datos para el ID proporcionado.");
            }
          } catch (error) {
            console.error("Error al obtener los datos desde la API:", error);
          }
        }
      }
    };

    fetchData(); // Llamar a la función asíncrona dentro de useEffect
  }, [idArt]);

  const handleSelectArticulo = (art_id, art_codigo, art_descripcion, art_npreciocosto) => {
    setForm((prevForm) => ({
      ...prevForm,
      ac_id_hijo: art_id,
      ac_codigo_hijo: art_codigo,
      art_descripcion: art_descripcion,
      costo: art_npreciocosto.toFixed(2),
    }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setForm((prevForm) => {
      let updatedForm = { ...prevForm };

      validateInput(name, value); // Valida el input antes de actualizar el formulario
      updatedForm[name] = value;

      // Recalcula el costototal si cambia ac_cantidad y se tiene un costo válido
      if (name === "ac_cantidad") {
        const costoUnitario = parseFloat(updatedForm.costo || 0); // Convierte costo a número
        const cantidadIngresada = parseFloat(value || 0); // Convierte ac_cantidad a número

        // Actualiza el costototal si los valores son válidos
        updatedForm.costototal = costoUnitario * cantidadIngresada || 0;
      }

      return updatedForm; // Retorna el formulario actualizado
    });
  };


  const validateInput = (name, value) => {
    let formErrors = {};

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: '',
    }));
    setErrors(formErrors);
    return Object.keys(formErrors).length === 0;
  };

  const validateForm = async () => {
    let formErrors = {};
    

    // Verificar si hay errores de validación
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return false;
    }

    // Verificar si el artículo ya existe
    const existente = await buscarExistente();
    if (existente && !idArt) {
      formErrors.ac_codigo_hijo = 'El artículo ya existe, no se puede duplicar';
      setErrors(formErrors);
      return false;
    }
    if (!form.ac_cantidad || isNaN(form.ac_cantidad) || form.ac_cantidad <= 0) {
      formErrors.ac_cantidad = 'La cantidad debe ser un número mayor a 0';
      setErrors(formErrors);
      return false;
    }
    

    setErrors({});
    return true; // El formulario es válido
  };

  const buscarExistente = async () => {

    // Buscar en el array temporal
    const encontradoArray = arrayCombo.find(item => item.ac_id_hijo === form.ac_id_hijo);

    if (encontradoArray) {
      return encontradoArray;
    }

    return null; // Devuelve null si no encuentra el elemento
  };

  const handleSendData = async () => {

    // Validar formulario
    const isFormValid = await validateForm();
    if (!isFormValid) {
      openErrorDialog("Por favor, corrige los errores antes de continuar.");
      return;
    }
    openConfirmDialog();
  };

  const confirmSendData = async () => {
    setIsSubmitting(true);
    closeConfirmDialog();
    try {
      const generateRandomId = () => {
        return Math.floor(Math.random() * 1000000) + Date.now();
      };

      // Dentro del handleSendData
      const idNuevo = selectedRow
        ? selectedRow.id // Si es edición, mantenemos el ID original
        : generateRandomId(); // Generamos un nuevo ID aleatorio para nuevos registros

        if (typeof form.Contenido_combo_hijo !== 'object' || form.Contenido_combo_hijo === null) {
          form.Contenido_combo_hijo = {}; // Inicializar como un objeto vacío si no existe o no es válido
        }
        
        // Agregar o actualizar el campo `art_descripcion` dentro de `Contenido_combo_hijo`
        form.Contenido_combo_hijo.art_descripcion = form.art_descripcion;
  
      // Nuevo objeto con oferta_Art incluido
      const newForm = {
        ...form, // Copiamos form sin art_descripcion
        id: idNuevo, 
      };

      // Procesar o enviar newForm según tu lógica

      if (idArt) {

        const comboEnArray = arrayCombo.find((item) => item.id === idArt);
        if (comboEnArray) {
          await updateItem("combo", comboEnArray.id, newForm.ac_cantidad);
          setEstadoForm(1);
        } else {
          try {
            const detalle = await getArticuloComboByIdData(idArt);
            if (detalle) {

              await patchArticuloComboData(detalle.id, newForm);
            } else {
              console.error("No se encontraron datos para el ID proporcionado.");
            }
          } catch (error) {
            console.error("Error al obtener los datos desde la API:", error);
          }
        }
      }
      else {
        addItem("combo", newForm);
      }

      // Restablecer formulario y cerrar modal
      resetForm();
      closeModal();
    } catch (error) {
      console.error("Error al guardar los datos:", error);
    } finally {
      setIsSubmitting(false);
    }
  };
  const openConfirmDialog = () => setIsConfirmDialogOpen(true);
  const closeConfirmDialog = () => setIsConfirmDialogOpen(false);

  const openErrorDialog = (message) => {
    setErrorMessage(message);
    setIsErrorDialogOpen(true);
  };

  const closeErrorDialog = () => setIsErrorDialogOpen(false);


  const resetForm = () => {
    setForm({
      ac_id_hijo: '',
      ac_codigo_hijo: '',
      art_descripcion: '',
      costo: 0,
      costototal: 0
    });
  };

  const handleCancel = () => {
    setSelectedRow('');
    setEstadoForm(0);
    resetForm();
    closeModal();
  };

  return (
    <>
      <div className="topOD">
        <h3>{title}</h3>
      </div>
      <div className="new">
        <div className="newContainerOD">
          <div className="bottomOD">
            <div className="rightOD">
              <form className="OD-form">
                {/* Código de artículo */}
                <div className="formInputOD">
                  {estadoForm === 1 ? (
                    <></>
                  ) : (
                    <>
                      <label>Busqueda</label>
                      <ArticulosModal
                        handleChange={setSearchIdArt}
                        handleDescChange={setSearchDescArt}
                        descSelected={searchIdArt}
                        onSelect={handleSelectArticulo}
                        findNoCombo={true}
                      />
                    </>

                  )}
                </div>
                <div className="formInputOD">
                  <label>Codigo</label>
                  <input
                    type="text"
                    name="ac_codigo_hijo"
                    value={form.ac_codigo_hijo || ''}
                    placeholder="Código de un artículo"
                    className={`inputNoEditable ${errors["ac_codigo_hijo"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["ac_codigo_hijo"] && <span className="error">{errors["ac_codigo_hijo"]}</span>}
                </div>
                <div className="formInputOD" style={{ display: 'none' }}>
                  <label>ID PADRE COMBO</label>
                  <input
                    type="int"
                    name="ac_id_padre"
                    value={form.ac_id_padre || ''}
                    placeholder="Código de un artículo"
                    className={errors["ac_id_padre"] ? 'inputError' : ''}
                    readOnly
                    hidden={true}
                  />
                  {errors["ac_id_padre"] && <span className="error">{errors["ac_id_padre"]}</span>}
                </div>
                {/* Descripción del artículo */}
                <div className="formInputOD">
                  <label>Descripción Del Artículo</label>
                  <input
                    type="text"
                    name="art_descripcion"
                    value={form.art_descripcion || ''}
                    placeholder="Articulo"
                    className={`inputNoEditable ${errors["art_descripcion"] ? 'inputError' : ''}`}
                    onChange={handleInputChange}
                  />
                  {errors["art_descripcion"] && <span className="error">{errors["art_descripcion"]}</span>}
                </div>

                {/* Costo + Flete */}
                <div className="formInputOD">
                  <label>Costo </label>
                  <input
                    type="number"
                    name="costo"
                    value={form.costo || ''}
                    placeholder="Costo"
                    className={`inputNoEditable ${errors["costo"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["costo"] && <span className="error">{errors["costo"]}</span>}
                </div>



                {/* Descuento */}
                <div className="formInputOD">
                  <label>Cantidad</label>
                  <input
                    type="number"
                    name="ac_cantidad"
                    value={form.ac_cantidad || ''}
                    placeholder="Ingrese la cantidad"
                    className={errors["ac_cantidad"] ? 'inputError' : ''}
                    onChange={handleInputChange}
                  />
                  {errors["ac_cantidad"] && <span className="error">{errors["ac_cantidad"]}</span>}
                </div>

                {/* Costo + Flete */}
                <div className="formInputOD">
                  <label>Costo Total</label>
                  <input
                    type="number"
                    name="costototal"
                    value={form.costototal || ''}
                    placeholder="Costo Total"
                    className={`inputNoEditable ${errors["costototal"] ? 'inputError' : ''}`}
                    readOnly
                  />
                  {errors["costototal"] && <span className="error">{errors["costototal"]}</span>}
                </div>
                {uploadFormError && <span className="error">{uploadFormError}</span>}

                {/* Botones */}
                <div className="btn-fieldOD">
                  <button
                    type="button"
                    className="OD-button"
                    onClick={handleSendData}
                    disabled={isSubmitting}
                  >
                    {isSubmitting ? 'Guardando...' : 'Guardar'}
                  </button>
                  <button
                    type="button"
                    className="cancel-buttonOD"
                    onClick={handleCancel}
                    disabled={isSubmitting}
                  >
                    Cancelar
                  </button>
                </div>
              </form>
              <ConfirmationDialog
                isOpen={isConfirmDialogOpen}
                onClose={closeConfirmDialog}
                onConfirm={confirmSendData}
                title=""
                message="¿Estás seguro de que deseas guardar este registro?"
              />
              <ErrorDialog
                isOpen={isErrorDialogOpen}
                onClose={closeErrorDialog}
                message={errorMessage}
                title=""
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormDetalle;
